export const EAutoType = {
  Auto: 0,

  NotAuto: 1,
} as const

export type EAutoType = (typeof EAutoType)[keyof typeof EAutoType]
